/* eslint-disable import/no-anonymous-default-export */
import { composeWithDevTools } from 'redux-devtools-extension'
import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import thunk from 'redux-thunk'

import rootReducer from './reducers'

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['loading', 'logs', 'orderPayment', 'returnOrder', 'banner'],
}

const middleware = [thunk]
const persistedReducer = persistReducer(persistConfig, rootReducer)
const composedEnhancer =
    process.env.REACT_APP_ENV === 'development'
        ? composeWithDevTools(applyMiddleware(...middleware))
        : applyMiddleware(...middleware)

export default () => {
    let store = createStore(persistedReducer, composedEnhancer)
    let persistor = persistStore(store)
    return { store, persistor }
}
